import { axiosClient } from '@as-react/common-utils';
const customerEndpoints = {
    customer: {
        social: {
            add: 'api/customer/social/insert',
        },
    },
};
class CustomerSocialMediaApi {
    addSocialMediaConnection(apiPrefix, params, data) {
        return new Promise((resolve, reject) => {
            const axiosConfig = {
                method: 'POST',
                url: `${apiPrefix}${customerEndpoints.customer.social.add}`,
                params,
                withCredentials: true,
                data,
            };
            axiosClient.request(axiosConfig).then(responseFromBackEnd => resolve(responseFromBackEnd.data), error => reject(error));
        });
    }
}
export default new CustomerSocialMediaApi();
